module.exports = __webpack_public_path__ + "static/PrimitiveFive-0dac80b0eb7553e1477acadc20deefaf.png";